export default {
	sentenceLength: {
		slightlyTooMany: 15,
		farTooMany: 20,
	},
};
